import React from "react";
import "../../Styles/Annotator/ubersicht.css";
import "../../Styles/Reports/nextpage.css";
import {Col} from "react-bootstrap"
import ReactPlayer from "react-player";
import {hasToken} from "../../Utils/Common";

class NextPage extends React.Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        hasToken();
    }

    render() {
        return (
            <div className="nextPageOuterContainer container">
                <br/>
                <Col className="nextPageCol">
                    <div className="block_container nextPageInnerContainer">

                        <div className="firstVideo graph-div text-center">
                            <div className="faq-video-display">

                                <h3 className="nextPageVideoTitle">1. Fragen an die Vergabestelle</h3>
                                <ReactPlayer controls={true} width={'100%'}
                                             url={"https://vimeo.com/507930945"}
                                />
                            </div>
                        </div>
                        <div className="secondVideo graph-div text-center">
                            <div className="faq-video-display">

                                <h3 className="nextPageVideoTitle">2. Antworten von der Vergabestelle</h3>
                                <ReactPlayer controls={true} width={'100%'}
                                             url={"https://vimeo.com/507921987"}
                                />
                            </div>
                        </div>
                        <div className="thirdVideo graph-div text-center">
                            <div className="faq-video-display">
                                <h3 className="nextPageVideoTitle">3. Ergebnis</h3>
                                <ReactPlayer controls={true} width={'100%'}
                                             url={"https://vimeo.com/507921921"}
                                />
                            </div>
                        </div>
                        <br/> <br/> <br/>
                    </div>
                </Col>
            </div>
        );
    }
}

export default NextPage;